module.exports = __webpack_public_path__ + "static/media/the-sydney-wine-academy.6c125317.png";